import React from "react";

/**
 * Decorative section label — uppercase wide-tracked title with twin
 * Franciscan-amber rule lines flanking it.
 */
export const SectionLabel = ({ children, icon, testid }) => (
  <div
    className="flex items-center gap-4 my-2"
    data-testid={testid}
    aria-label={typeof children === "string" ? children : undefined}
  >
    <span
      className="h-px flex-1"
      style={{
        background:
          "linear-gradient(to right, transparent 0%, rgba(212,160,91,0.45) 100%)",
      }}
    />
    <span
      className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full text-[11px] sm:text-xs uppercase tracking-[0.32em] font-semibold"
      style={{
        background: "rgba(20,17,13,0.7)",
        color: "var(--mt-amber-bright)",
        border: "1px solid rgba(212,160,91,0.35)",
        backdropFilter: "blur(8px)",
      }}
    >
      {icon}
      {children}
    </span>
    <span
      className="h-px flex-1"
      style={{
        background:
          "linear-gradient(to left, transparent 0%, rgba(212,160,91,0.45) 100%)",
      }}
    />
  </div>
);

export default SectionLabel;
